import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe, formatDate } from '@angular/common';
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { CustomerService } from '../_services/customer.service';
import { AccountService } from '../_services/account.service';
import { InvoicesService } from '../_services/invoices.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { AppConfig, ExcelService } from '../_helpers/index';
import { DebtorService } from '../_services/debtor.service';
import { PaymentProcessService } from '../_services/paymentprocess.service';

import { ParameterData } from '../_helpers/index';
import { Router, ActivatedRoute } from '@angular/router';
import { accountBankCategoryStatus, accountBankStatus, accountBankType, accountPSPCreation, accountPSPType } from '../_enums/account';
import { DataService } from '../_helpers/dataservice.service'
import { PSPOperation, PaymentProcess, Invoice } from '../_models';
import { AuthService } from '../_services/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountTypeOptions } from '../sharedcomp/constans/routes.constans';


@Component({
  selector: 'accountoperationbankcategorize',
  templateUrl: './accountoperationbankcategorize.component.html',
  styleUrls: ['./categorize.component.css']
})

export class AccountsOperationBankCategorizeComponent implements OnInit, OnDestroy {

  public customer_public_id: string;
  public customer_Account_public_id: string;

  excelExportData: any;
  ddlStatus: any[];

  public paymentID = true;
  public depositID = false;
  public transferID = false;

  public checkName = false;
  public Error: any;
  public CreatedDate: string;
  public noValue = false;

  ddlTransType: any[];
  ddlBankCreation: any[];
  ddlAccountType: any[];
  invoiceTotalAmt: number = 0.0;
  currencysymbol: any;
  isalertVisiable: boolean;
  searchDebtorFilterForm: FormGroup;
  searchFilterForm: FormGroup;
  searchRangoFilterForm: FormGroup;
  displayedColumns: string[] = ['select', 'created', 'processing', 'total.value', 'reference', 'metadata.process_type', 'metadata.debtor.name', 'status'];
  columnsToDisplay: string[] = this.displayedColumns.slice();
  dataSourceAccOperationBankList = new MatTableDataSource();

  displayedColumnsInvoice: string[] = ['select', 'created', 'name', 'total.value', 'status'];
  dataSourceInvoicesList = new MatTableDataSource();
  selection = new SelectionModel<any>(true, []);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  filterValue;
  customerPublic_key;
  isRangoVisiable = false;
  auth0Profile: any;
  public debtorPublicID: any;
  public debtorPromiseResult: any = "";
  public searchRef: any = "";
  cust_account_name: any;
  public selectinvoicelist: Invoice[] = [];
  psp_OperationPublic_key: any;
  psp_OperationPublic_Id: any;
  psp_OperationTotalAmt: any;
  public elementDebtor: any;
  public user_id: string;

  public paymentprocessForm: FormGroup;
  public _paymentprocess: any;
  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;
  isRangoStatus = "None";
  enableConfirmBtn: boolean;
  pageIndexVal: number;

  /** This is Constructor function which is used to initialize the class variables and objects; 
   */
  constructor
    (
      private router: Router, private formBuilder: FormBuilder,
      private _fb: FormBuilder, private excelService: ExcelService
      , private parameterData: ParameterData, private dataService: DataService
      , private customerService: CustomerService
      , private invoicesService: InvoicesService
      , private datePipe: DatePipe
      , private accountService: AccountService
      , private auth: AuthService
      , private readonly activatedRoute: ActivatedRoute
      , private _accountBankStatus: accountBankStatus
      , private _accountBankCategoryStatus: accountBankCategoryStatus
      , private _accountBankType: accountBankType
      , private _acctype: accountPSPType
      , private _accountpspcreation: accountPSPCreation
      , private spinnerService: Ng4LoadingSpinnerService
      , private debtorService: DebtorService
      , private paymentProcessService: PaymentProcessService
      , private _fbpayprocess: FormBuilder
    ) {
    this.spinnerService.show();

    this.ddlStatus = _accountBankCategoryStatus._accountBankCategoryStatus;
    this.ddlBankCreation = _accountpspcreation._accountpspcreation;
    this.ddlTransType = _accountBankType._accountBankType;
    this.ddlAccountType = _acctype._accountPSPType;
    this.enableConfirmBtn = false;

  }//end 




  /** This function is used to work the text filter above the grid; 
   */
  applyFilter() {

    this.filterValue = this.searchFilterForm.controls.searchText.value;
    this.filterValue = this.filterValue.trim();
    this.filterValue = this.filterValue.toLowerCase();
    this.dataSourceAccOperationBankList.filter = this.filterValue;
  }//end


  applyDebtorFilter() {

    this.filterValue = this.searchDebtorFilterForm.controls.searchText.value;
    this.filterValue = this.filterValue.trim();
    this.filterValue = this.filterValue.toLowerCase();
    this.invoiceTotalAmt = 0;
    this.noValue = false;
    if (this.filterValue !== undefined && this.filterValue != '') {

      this.Error = ' ';
      this.debtorService.searchDebtor(this.customer_public_id, "", this.filterValue)
        .subscribe((data) => {
          let resources = data["data"];
          this.debtorPromiseResult = resources;
          if (resources !== undefined && resources != null && resources != '') {
            this.checkName = true;
            this.debtorPromiseResult = resources[0].name;
            this.debtorPublicID = resources[0].public_id;
            this.getcustDebtorInvoiceListNEW(resources[0]);
          }
          else {
            this.checkName = false;
            this.Error = 'No se encontro cliente';
            let res;
            this.debtorPromiseResult = res;
          }

        },
          error => {
            this.Error = 'No se encontro cliente';

          });

    }
    else {
      this.Error = 'No se encontro cliente';
      let res;
      this.debtorPromiseResult = res;
    }

  }//end


  /** This is ngOnInit function called after initialising the component; 
 */
  ngOnInit() {
    var browserStorage;
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customer_public_id = localStorage.getItem('companyId');
        this.user_id = localStorage.getItem('userId');
      }
    }
    else {
      this.customer_public_id = localStorage.getItem('subcompanyId');
      this.user_id = localStorage.getItem('userId');
    }

    //////////////////////////

    browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
    this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');
    if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {

      this.offsetTimeZone = -5.00;
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    else {

      this.offsetTimeZone = browserStorage.getItem('timezone');
      this.offsetMinutes = 30;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;


    }
    //used to retrieve the customer Account public id
    let params: any = this.activatedRoute.snapshot.params;
    this.customer_Account_public_id = params.id;
    this.psp_OperationPublic_key = params.idc;
    this.pageIndexVal = params.pageIndexDynamic;

    this.setPage(this.pageIndexVal);

    this.searchDebtorFilterForm = this.formBuilder.group({
      searchText: ['', Validators.required]
    });

    this.searchFilterForm = this.formBuilder.group({
      searchText: ['', Validators.required]
    });

    this.searchRangoFilterForm = this._fb.group({
      searchFromDate: [''],
      searchToDate: ['']
    });


    if (this._accountpspcreation._accountpspcreation.length > 8) {
      this._accountpspcreation._accountpspcreation.shift();
    }

    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";
    this.InitialSetup();
    this.GetAccountsDetails();
    this.GetCustomerAccountsOperationBankList();

    this.dataSourceAccOperationBankList.paginator = this.paginator;
    this.dataSourceAccOperationBankList.sort = this.sort;

  }//end

  ngOnDestroy() {

  }//end

  setPage(index: number) {
    setTimeout(() => {
      this.paginator.pageIndex = index;
    }, 100);
  }
  /*
       This function is used to initialize form controls
*/
  InitialSetup() {

    this.paymentprocessForm = this._fbpayprocess.group({
      is_confirmed: new FormControl(""),
      reference: new FormControl(""),
      external_id: new FormControl(""),
      public_id: new FormControl(""),
      status: new FormControl(""),

      debtor: this._fbpayprocess.group({
        public_id: new FormControl("")
      }),

      user: this._fbpayprocess.group({
        public_id: this.user_id
      }),


      psp_operation: this._fbpayprocess.group({

        public_id: new FormControl(""),
        customer_account: this._fbpayprocess.group({
          public_id: new FormControl("")
        }),
        psp_account: this._fbpayprocess.group({
          public_id: new FormControl("")
        }),
        total: this._fbpayprocess.group({
          currency: new FormControl(""),
          value: new FormControl("")
        })
      }),
      invoice_list: this._fbpayprocess.array([
        ({
          id: [""],
          public_id: [""],
          late_fee: this._fbpayprocess.group({
            currency: [""],
            symbol: [""],
            value: (0)
          }),
          sub_total: this._fbpayprocess.group({
            currency: [""],
            symbol: [""],
            value: (0)
          }),
          total: this._fbpayprocess.group({
            currency: [""],
            symbol: [""],
            value: (0)
          })
        })
      ])
    });
  }
  //end initial setup

  /** This function is used to get the invoices list from the service; 
 * it accepts the param customerId
 */
  GetCustomerAccountsOperationBankList() {

    setTimeout(() => {
      this.accountService.getAccountOperationListBank(this.customer_Account_public_id).subscribe(data => {
        let resources = data["data"];
        this.dataSourceAccOperationBankList.data = resources;
        this.excelExportData = resources;

        this.elementDebtor = resources.filter(t => t.public_id == this.psp_OperationPublic_key);


        this.getDebtorDetails(this.elementDebtor[0]);

        this.spinnerService.hide();
      },
        error => {
          console.log('Failed! while trying to get the invoices list. ' + error);
        });
    }, 500);

  }//end

  /**
* this function is used to get the customer account public id details.
*/

  getDebtorDetails(element) {

    this.searchRef = element.reference;
    this.currencysymbol = element.total.symbol;
    this.psp_OperationTotalAmt = element.total.value;
    this.psp_OperationPublic_Id = element.public_id;

    this.Error = ' ';
    this.invoiceTotalAmt = 0;
    this.debtorService.searchDebtor(this.customer_public_id, "", element.reference)
      .subscribe((data) => {
        let resources = data["data"];

        if (resources !== undefined && resources != null && resources != '') {
          this.checkName = true;
          this.debtorPromiseResult = resources[0].name;
          this.debtorPublicID = resources[0].public_id;
          this.searchRef = resources[0].document_id;
          this.getcustDebtorInvoiceListNEW(resources[0]);

        }
        else {
          this.noValue = false;
          this.checkName = false;
          this.searchRef = " ";
          this.Error = 'No se encontro cliente';
          let res;
          this.debtorPromiseResult = res;
        }

      },
        error => {
          this.Error = 'No se encontro cliente';

        });
  }



  /**
 * this function is used to get the debtor invoice list .
 */
  getcustDebtorInvoiceListNEW(element) {

    if (element !== undefined) {
      if (element.public_id !== undefined || element.public_id != null) {

        this.debtorService.getDebtorInvoiceListWithFilters(element.public_id)
          .subscribe(data => {
            let resources = data["data"];
            this.dataSourceInvoicesList.data = resources;
            this.dataSourceInvoicesList.data = resources.filter(d => d.total.symbol == this.currencysymbol);


            if (element.name !== undefined || element.name != null) {
              this.debtorPromiseResult = element.name;
              this.checkName = true;

              if (typeof resources !== 'undefined' && resources.length > 0) {
                this.noValue = true;
              }
              else {
                this.noValue = false;
              }

            }
            else {
              this.checkName = false;
              this.noValue = false;
              this.searchRef = " ";
            }

          });
      }
      else {
        let resources;
        this.dataSourceInvoicesList.data = resources;
        this.debtorPromiseResult = '';
      }
    }
    else {
      this.checkName = false;
      this.noValue = false;
      let resources;
      this.dataSourceInvoicesList.data = resources;
      this.debtorPromiseResult = '';
    }

  }//end

  /**
   * this function is used to get the debtor invoice list .
   */
  getcustDebtorInvoiceList(element) {


    if (element.metadata !== undefined) {
      if (element.metadata.debtor.public_id !== undefined || element.metadata.debtor.public_id != null) {
        this.debtorPublicID = element.metadata.debtor.public_id;
        this.debtorService.getDebtorInvoiceListWithFilters(element.metadata.debtor.public_id)
          .subscribe(data => {
            let resources = data["data"];
            this.dataSourceInvoicesList.data = resources;


            if (element.metadata.debtor.name !== undefined || element.metadata.debtor.name != null) {
              this.debtorPromiseResult = element.metadata.debtor.name;
              this.checkName = true;
              this.noValue = true;
            }
            else {
              this.checkName = false;
              this.noValue = false;
            }
            this.dataSourceInvoicesList.filter = '';
          });
      }
      else {
        let resources;
        this.dataSourceInvoicesList.data = resources;
        this.debtorPromiseResult = '';
      }
    }
    else {
      this.checkName = false;
      this.noValue = false;
      let resources;
      this.dataSourceInvoicesList.data = resources;
      this.debtorPromiseResult = '';
    }

  }//end


  /** This function is used to get the account account details from the service; 
   * it accepts the param account public id
   */
  GetAccountsDetails() {
    this.accountService.getAccount(this.customer_Account_public_id).subscribe(data => {
      this.cust_account_name = data.name;
    },
      error => {
        console.log('Failed! while trying to get the acccount details list. ' + error);
      });
  }//end


  onsubmit({ value }: { value: PaymentProcess }) {

    if (this.invoiceTotalAmt > 0) {
      value.invoice_list = this.selectinvoicelist;
      value.is_confirmed = true;
      value.reference = this.searchRef;
      value.name = "EFECTIVO # " + this.searchRef;
      value.debtor.public_id = this.debtorPublicID;
      value.psp_operation.public_id = this.psp_OperationPublic_Id;
      value.psp_operation.total.currency = this.currencysymbol;
      value.psp_operation.total.value = this.invoiceTotalAmt;
      value.psp_operation.customer_account.public_id = this.customer_Account_public_id;

      this.paymentProcessService.createPayment(value)
        .subscribe((result) => {
          this.noValue = false;
          this.checkName = false;
          this.searchRef = " ";
          this.invoiceTotalAmt = 0;
          this.debtorPromiseResult = " ";
          this.GetCustomerAccountsOperationBankList();
          this.dataSourceAccOperationBankList.paginator = this.paginator;
          this.dataSourceAccOperationBankList.sort = this.sort;

          this.searchDebtorFilterForm.reset();

        }, error => {
          console.log('Failed while trying to update the Payments Process Details.' + error);
        });
    }
    else {
      alert("Please select the Invoice Amount");
      this.isalertVisiable = true;
    }

  }


  onPaymentClick() {
    this.depositID = false;
    this.paymentID = true;
    this.transferID = false;
  }

  onDespositClick() {
    this.depositID = true;
    this.paymentID = false;
    this.transferID = false;

  }

  onTransferClick() {
    this.depositID = false;
    this.paymentID = false;
    this.transferID = true;

  }
  /** This function is used to export the invoices list to the excel file; 
   * it reads the data from the variable excelExportData which is assigened when the lits bind in to the grid
   */
  exportAsXLSX() {
    this.excelService.exportAsExcelFile(this.excelExportData, 'InvoicesList');
  }//end

  /** This function is used to filter the Account list based on Creation Detail wise; 
   * it accepts the param select status value
   */
  filterAccountTransDetails(accounttype) {

    if (accounttype == this.ddlTransType[0].value) {
      this.dataSourceAccOperationBankList.filter = '';
    }
    else {
      this.dataSourceAccOperationBankList.filter = '';
      this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) =>
        data.type == accounttype;
      this.dataSourceAccOperationBankList.filter = accounttype;
    }

  }//end


  /** This function is used to filter the Account list based on Creation Detail wise; 
   * it accepts the param select status value
   */
  filterAccountTypeDetails(accounttype) {

    if (accounttype == this.ddlAccountType[0].value) {
      this.dataSourceAccOperationBankList.filter = '';
    }
    else {
      this.dataSourceAccOperationBankList.filter = '';
      this.dataSourceAccOperationBankList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.psp_operation.metadata.process_type == accounttype;
      this.dataSourceAccOperationBankList.filter = accounttype;
    }

  }//end


  /** This function is used to filter the Account list based on Status Detail wise; 
     * it accepts the param select status value
     */

  filterAccountStatusDetails(status) {

    if (status == this.ddlStatus[0].value) {

      this.dataSourceAccOperationBankList.filter = '';
    }
    else if (status == this.ddlStatus[1].value) {
      this.dataSourceAccOperationBankList.filter = '';

      this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) =>
        data.status == 'NEW';


    }
    else if (status == this.ddlStatus[2].value) {
      this.dataSourceAccOperationBankList.filter = '';
      this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) =>
        data.status == 'CONFIRMED';

      this.dataSourceAccOperationBankList.filter = 'CONFIRMED';
    }
    else if (status == this.ddlStatus[3].value) {
      this.dataSourceAccOperationBankList.filter = '';
      this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) =>
        data.status == 'CANCELLED';

      this.dataSourceAccOperationBankList.filter = 'CANCELLED';
    }
    else if (status == this.ddlStatus[4].value) {
      this.dataSourceAccOperationBankList.filter = '';
      this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) =>
        data.status == 'CATEGORIZED';

      this.dataSourceAccOperationBankList.filter = 'CATEGORIZED';
    }
    else if (status == this.ddlStatus[5].value) {
      this.dataSourceAccOperationBankList.filter = '';
      this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) =>
        data.status == 'PROCESSED';

      this.dataSourceAccOperationBankList.filter = 'PROCESSED';
    }
    else if (status == this.ddlStatus[6].value) {
      this.dataSourceAccOperationBankList.filter = '';
      this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) =>
        data.status == 'RECONCILED';

      this.dataSourceAccOperationBankList.filter = 'RECONCILED';
    }
  }

  //end



  /*
  * This function is used to filter the invoices list based on Creation details based; 
  * it accepts the param select Creation Date values      
  */

  filterAccountCreationDetails(creation) {

    var currentDate = new Date();

    var currentweekFirstDate = new Date();
    var currentweekLastDate = new Date();

    var lastweekFirstDate = new Date();
    var lastweekLastDate = new Date();

    currentweekFirstDate.setDate(currentweekFirstDate.getDate() - currentweekFirstDate.getDay());
    currentweekLastDate.setDate(currentweekFirstDate.getDate() + 7);

    var currentmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    var currentmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    var lastmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    var lastmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

    lastweekFirstDate.setDate(lastweekFirstDate.getDate() - 7);
    lastweekLastDate.setDate(lastweekFirstDate.getDate() + 6);



    // All Datas Condition
    if (creation == 0) {
      this.dataSourceAccOperationBankList.filter = '';
    }

    // Current Month Filter Condition
    if (creation == 1) {
      this.dataSourceAccOperationBankList.filter = '';
      let CurrentmonthFirstDate = formatDate(currentmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let CurrentmonthEndDate = formatDate(currentmonthLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');

      this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) =>
        data.created >= CurrentmonthFirstDate && data.created <= CurrentmonthEndDate;

    }

    // Current Week Filter Condition
    if (creation == 2) {
      this.dataSourceAccOperationBankList.filter = '';
      var WeekstartDate1 = new Date(formatDate(currentweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      var WeekendDate1 = new Date(formatDate(currentweekLastDate, 'yyyy-MM-dd 23:59:00', 'en-US'));

      let WeekstartDate = this.convertGMTTime(WeekstartDate1);
      let WeekendDate = this.convertGMTTime(WeekendDate1);


      this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) =>
        data.created >= WeekstartDate && data.created <= WeekendDate;

    }

    // Today Filter Condition
    if (creation == 3) {

      this.dataSourceAccOperationBankList.filter = '';
      currentDate.setDate(currentDate.getDate());
      currentDate.setDate(currentDate.getDate());

      var todayStartDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let startDate = this.convertGMTTime(todayStartDate);

      var todayEndDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:00', 'en-US'));
      let endDate = this.convertGMTTime(todayEndDate);

      this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) =>
        data.created >= startDate && data.created <= endDate;
    }

    // Yesterday Filter Condition
    if (creation == 4) {
      this.dataSourceAccOperationBankList.filter = '';
      currentDate.setDate(currentDate.getDate() - 1);

      var yesterdayStartDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let startDate = this.convertGMTTime(yesterdayStartDate);

      var yesterdayEndDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:00', 'en-US'));
      let endDate = this.convertGMTTime(yesterdayEndDate);

      this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) =>
        data.created >= startDate && data.created <= endDate;
    }


    // Last Week Filter Condition
    if (creation == 5) {
      this.dataSourceAccOperationBankList.filter = '';

      var lastWeekstartDate1 = new Date(formatDate(lastweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let lastWeekstartDate = this.convertGMTTime(lastWeekstartDate1);

      var lastWeekendDate1 = new Date(formatDate(lastweekLastDate, 'yyyy-MM-dd 23:59:00', 'en-US'));
      let lastWeekendDate = this.convertGMTTime(lastWeekendDate1);


      this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) =>
        data.created >= lastWeekstartDate && data.created <= lastWeekendDate;



    }

    // Last Month Filter Condition
    if (creation == 6) {
      this.dataSourceAccOperationBankList.filter = '';
      var LastmonthFirstDate1 = new Date(formatDate(lastmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let LastmonthFirstDate = this.convertGMTTime(LastmonthFirstDate1);

      var LastmonthEndDate1 = new Date(formatDate(lastmonthLastDate, 'yyyy-MM-dd 23:59:00', 'en-US'));
      let LastmonthEndDate = this.convertGMTTime(LastmonthEndDate1);

      this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) =>
        data.created >= LastmonthFirstDate && data.created <= LastmonthEndDate;

    }
    if (creation != 0) {
      this.dataSourceAccOperationBankList.filter = '2018-10-24 01:59:45';
    }


    // Range Filter Condition
    if (creation == 7) {
      this.isRangoStatus = "creation";
      this.isRangoVisiable = true;

    }
    else {
      this.isRangoStatus = "None";
      this.isRangoVisiable = false;
    }
  }//end

  filterAllDetails() {


    if (this.searchRangoFilterForm.controls.searchFromDate.value !== null && this.searchRangoFilterForm.controls.searchToDate.value !== null
      && this.searchRangoFilterForm.controls.searchFromDate.value !== '' && this.searchRangoFilterForm.controls.searchToDate.value !== ''
    ) {




      if (this.isRangoStatus == "creation") {
        this.filterRangoDetails();
      }
    }
    else {


      this.isRangoVisiable = false;

    }

  }


  /** This function is used to filter the invoices list based on Rango From and To Date wise; 
* it accepts the param select status value
*/
  filterRangoDetails() {

    if (this._accountpspcreation._accountpspcreation.length > 8) {
      this._accountpspcreation._accountpspcreation.shift();
    }

    if (this.searchRangoFilterForm.controls.searchFromDate.value != '' && this.searchRangoFilterForm.controls.searchToDate.value != '') {
      this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value, "dd/MM/yyyy") + '-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value, "dd/MM/yyyy");

      this.ddlBankCreation.unshift({ value: 8, name: this.filterValue });

      this.isRangoVisiable = false;

      ///////////////////////////////////////////////////////

      this.dataSourceAccOperationBankList.filter = '';
      let CurrentmonthFirstDate = formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US');
      let CurrentmonthEndDate = formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceAccOperationBankList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.created >= CurrentmonthFirstDate && data.created <= CurrentmonthEndDate;

      this.dataSourceAccOperationBankList.filter = '2018-10-24 01:59:45';
      ///////////////////////////////////////////////////////////
    }

  }//end


  convertGMTTime(startDate1) {
    if (this.offsetTimeZone > 0) {
      let date: any = new Date(startDate1);
      var dateTimeZoneDiff = new Date(date);
      dateTimeZoneDiff.setMilliseconds(Number(this.offsetTimeVal));
      let startDate = formatDate(dateTimeZoneDiff, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    }
    else {
      var startDate2 = new Date(startDate1.setHours(startDate1.getHours() - this.offsetTimeZone));
      var startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes() - this.offsetMinutes));
      let startDate = formatDate(startDate3, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    }
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSourceInvoicesList.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
    }
    else {
      this.dataSourceInvoicesList.data.forEach(row => this.selection.select(row));
    }
  }


  /** Selects individual row if they are not selected; otherwise clear selection. */
  selectRow(row) {

    if (this.selection.isSelected(row)) {
      this.selection.toggle(row);
      this.invoiceTotalAmt = this.invoiceTotalAmt - row.total.value;
    }
    else {
      this.selection.toggle(row);
      this.invoiceTotalAmt = this.invoiceTotalAmt + row.total.value;
      this.selectinvoicelist.push(row);
    }

    if (this.psp_OperationTotalAmt == this.invoiceTotalAmt) {
      this.enableConfirmBtn = true;
    }
    else {
      this.enableConfirmBtn = false;
    }
  }

  viewInvoiceDetails(element) {

    const application = localStorage.getItem('application');
    this.dataService.changeinvoicepublicKey(element.public_id);
    if (AccountTypeOptions[application] != undefined) {
      this.router.navigate([`/${AccountTypeOptions[application]}/invoices/${element.public_id}/view`]);
    }
  }

  btngoBack() {
    this.router.navigate([`/accounts/bank/${this.customer_Account_public_id}/operations`]);
  }
}//end class


